import { render, staticRenderFns } from "./leaderboard-projected-highlights.vue?vue&type=template&id=27d9f696&scoped=true&"
import script from "./leaderboard-projected-highlights.vue?vue&type=script&lang=js&"
export * from "./leaderboard-projected-highlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d9f696",
  null
  
)

export default component.exports